import useGetValue from '../hooks/useGetValue';
import styles from './EditProperty.module.scss';

const EditProperty = ({ payload, submit }) => {
  const currentValue = useGetValue(payload.id);

  const onChange = (e) => {
    submit({
      field: e.target.checked ? 1 : 0,
    });
  };

  return (
    <div className={styles.checkboxWrapper}>
      <div className={styles.checkbox}>
        <input type="checkbox" className={styles.ikxBAC} onChange={onChange} checked={Boolean(currentValue)} />
      </div>
      <span>{currentValue ? 'true' : 'false'}</span>
    </div>
  );
};

export default EditProperty;
